<template>
  <div
    :to="`/product/${info.cprcode}`"
    class="card-product row"
    style="text-decoration: none"
  >
    <div class="col-4 flex items-start q-pa-xs">
      <q-img
        basic
        :placeholder-src="require('@/assets/image-not-found.png')"
        height="90px"
        contain
        :src="imageSrc"
        class="img"
        @error="retryImageSrc(info.cprcode, info.pr_use_original_img)"
      ></q-img>
    </div>
    <div
      class="col-8 column detail"
      :style="`
          ${
            showShadow
              ? 'box-shadow: -2.8px 0px 2.2px rgba(245, 245, 255, 1);'
              : ''
          }
            padding:10px 0
        `"
    >
      <div>
        <div class="brand">{{ info.hemaNameEn }}</div>
        <div class="row">
          <div class="col-6 text-dark-grey description">
            {{ info.hemaBrandEn }}
          </div>
          <div class="col-6 text-right text-dark-grey description q-pr-sm">
            {{ info.hemaSizedesc }}
          </div>
          <div class="col-6 text-dark-grey description q-pr-sm">
            SKU {{ info.cprcode }}
          </div>
        </div>
        <div class="text-dark-grey description q-mr-sm" style="font-size: 12px">
          Current branch stock: {{ stock }}
        </div>
        <div v-if="SortedAvailableStore">
          <div
            v-for="n in 3"
            :key="n"
            class="text-dark-grey description q-mr-sm"
            style="font-size: 12px"
          >
            <div
              v-if="
                SortedAvailableStore[n - 1] && SortedAvailableStore[n - 1][2]
              "
            >
              {{ SortedAvailableStore[n - 1][2] }} stock:
              {{ SortedAvailableStore[n - 1][1].inventory.stock }}
            </div>
          </div>
        </div>

        <div class="row q-gutter-xs q-mr-sm">
          <q-badge
            v-if="preorder.preType === 'Relative'"
            class
            outline
            color="lime-10"
            >{{ preorder.preRelativeDay }} day advance order</q-badge
          >
          <q-badge v-if="preorder.type === 'Fixed'" outline color="lime-10"
            >Delivery on {{ displayDeliveryDate }}</q-badge
          >
          <!-- <q-badge outline color="blue">+100 Pt</q-badge> -->
        </div>
      </div>
      <div v-if="two4discount">
        <q-badge class outline color="red-10">
          Buy 2 save ฿ {{ two4discount }}
        </q-badge>
      </div>
      <!-- <q-skeleton v-if="inventoryLoading" width="96%" height="30px" /> -->
      <!-- <div v-if="preorder_type" class="row q-mb-xs q-mr-sm">
                    <q-btn
                        block
                        class="row col-12 no-border-radius"
                        style="margin-top:10px;"
                        color="primary"
                        :size="`${10}px`"
                        label="Pre Order"
                    />
                </div> -->
      <div v-if="isShopAtStore" class="row q-mb-xs q-mr-sm">
        <div class="row items-baseline self-end">
          <!-- <q-skeleton
                            v-if="priceLoading"
                            class="col-12"
                            type="text"
                            height="40px"
                            width="80px"
                        /> -->
          <div>
            <span class="special-price" style="color: #575757">
              <span style="font-size: 14px">฿</span>
              {{ $priceFormat(price) }}
            </span>
            <span
              v-if="lastPrice"
              class="special-price"
              style="color: #979797; text-decoration: line-through"
            >
              <span style="font-size: 14px">฿</span>
              {{ $priceFormat(lastPrice) }}
            </span>
            <span v-if="lastPrice" class="discount-price"
              >-{{ calculateDiscount }}%</span
            >
            <span v-if="info.unit" class="unit-price"> /{{ info.unit }} </span>
          </div>
          <!-- <div class="price">฿{{ price }}</div> -->
        </div>
        <div class="col-grow" />
        <q-btn rounded color="dark" :size="`7px`" aria-label="add to cart">
          <div class="row items-center no-wrap">
            <q-icon left name="shopping_cart" />
            <div class="text-center">Store<br />Only</div>
          </div>
        </q-btn>
      </div>

      <div class="row q-mb-xs q-mr-sm">
        <div class="row items-baseline self-end">
          <!-- <q-skeleton
                            v-if="priceLoading"
                            class="col-12"
                            type="text"
                            height="40px"
                            width="80px"
                        /> -->
          <div>
            <span class="special-price">
              <span style="font-size: 14px">฿</span>
              {{ $priceFormat(price) }}
            </span>
            <span
              v-if="lastPrice"
              class="special-price"
              style="color: #575757; text-decoration: line-through"
              ><span style="font-size: 14px">฿</span>
              {{ $priceFormat(lastPrice) }}
            </span>
            <span v-if="lastPrice" class="discount-price"
              >-{{ calculateDiscount }}%</span
            >
            <span v-if="info.unit" class="unit-price">/{{ info.unit }}</span>
          </div>
        </div>
        <div class="col-grow text-right">
          <div v-if="atToCard <= 0">
            <q-btn
              round
              color="primary"
              :size="`${10}px`"
              icon="shopping_cart"
              aria-label="add to cart"
              @click.prevent="addToCart(info)"
            />
          </div>
          <div
            v-else
            style="
              display: flex;
              justify-content: flex-end;
              align-items: center;
            "
          >
            <div>
              <q-btn
                round
                dense
                color="primary"
                :size="`${10}px`"
                aria-label="remove from cart"
                @click.prevent="subtract(info)"
              >
                <i class="fas fa-minus"></i>
              </q-btn>
            </div>
            <p class="special-price" style="padding: 0 10px; margin: 0px">
              {{ atToCard }}
            </p>
            <div>
              <q-btn
                round
                dense
                color="primary"
                :size="`${10}px`"
                icon="add"
                aria-label="add to cart"
                @click.prevent="addToCart(info)"
              >
              </q-btn>
            </div>
            <q-btn
              rounded
              class="q-ml-sm"
              color="primary"
              :size="`${10}px`"
              label="Edit"
              aria-label="add to cart"
              @click.prevent="customQuantityDialog(info)"
            >
            </q-btn>
          </div>
        </div>
      </div>
    </div>

    <q-img basic v-if="badge.left" :src="`${badge.left}`" class="overlay" />
    <q-img
      basic
      v-if="badge.right"
      :src="`${badge.right}`"
      class="overlay-right"
    />
    <!-- <q-dialog v-model="customQuantityDialog"> </q-dialog> -->
  </div>
</template>

<script>
import priceFormat from "@/utils/priceFormat";
import imageSrc from "@/mixins/imageSrc";
import preorder from "@/mixins/preorder";
import useCart from "@/mixins/useCart";
import discount from "@/mixins/discount";
import isShopAtStore from "@/mixins/isShopAtStore";
import { QBadge } from "quasar";
import { mapState } from "vuex";
import { mini } from "@/settings/branchs";

export default {
  name: "ProductCardH",
  props: ["info"],
  components: {
    QBadge,
  },
  mixins: [imageSrc, preorder, useCart, discount, isShopAtStore],
  data() {
    return {
      loading: false,
      showShadow: false,
      atToCard: 0,
      // customQuantityDialog: false,
    };
  },
  computed: {
    ...mapState({
      basket: (state) => state["cart"]["basket"],
    }),
    badge() {
      return {
        left: this.info.badgeLeft,
        right: this.info.badgeRight,
      };
    },
    two4discount() {
      return this.info.two4discount;
    },
    branchCode() {
      return parseInt(this.$store.state["branch"]["branch"].code);
    },
    price() {
      if (this.info.availableStore.get(this.branchCode)) {
        const store = this.info.availableStore.get(this.branchCode);
        if (store.price) {
          return store.price.price;
        }
      }
      return 0;
    },
    lastPrice() {
      if (this.info.availableStore.get(this.branchCode)) {
        const store = this.info.availableStore.get(this.branchCode);
        if (store.price) {
          if (store.price.price !== store.price.lastPrice) {
            return store.price.lastPrice;
          }
        }
      }
      return 0;
    },
    stock() {
      if (this.info.availableStore.get(this.branchCode)) {
        const store = this.info.availableStore.get(this.branchCode);
        if (store.inventory) {
          return store.inventory.stock;
        }
      }
      return 0;
    },
    SortedAvailableStore() {
      let list = [...this.info.availableStore];
      list = list.filter((l) => {
        if (l[1]) {
          if (l[1].inventory) {
            if (l[1].inventory.stock && l[0] !== this.branchCode) {
              return true;
            }
          }
        }
        return false;
      });
      list.sort((a, b) => {
        // console.log("SortedAvailableStore", a, b);
        if (a[1].inventory.stock < b[1].inventory.stock) {
          return -1;
        }
        if (a[1].inventory.stock > b[1].inventory.stock) {
          return 1;
        }
        return 0;
      });

      //add branch name
      // console.log(list);
      list.forEach((l, index) => {
        const name = mini().find((b) => b.code === l[0].toString()).name;
        list[index].push(name);
      });

      return list.reverse();
    },
  },
  watch: {
    "info.cprcode": {
      handler: function (cprcode) {
        this.initializeImageSrc(cprcode, this.info.prUseOriginalImg);
      },
    },
    "basket.productList": {
      // immediate: true,
      handler: function () {
        console.log("watch basket");
        let result = null;
        if (this.basket.productList) {
          result = this.basket.productList.find((p) => {
            return p.sku === this.info.cprcode;
          });
        }
        if (result) {
          console.log("result:", result);
          this.atToCard = result.quantity;
        } else {
          this.atToCard = 0;
        }
      },
    },
  },
  mounted() {
    this.showShadow = false;
    this.initializeImageSrc(this.info.cprcode, this.info.prUseOriginalImg);
    if (this.basket) {
      // console.log("has basket");
      let result = null;
      if (this.basket.productList) {
        result = this.basket.productList.find((p) => {
          return p.sku === this.info.cprcode;
        });
      }
      if (result) {
        console.log("result:", result);
        this.atToCard = result.quantity;
      } else {
        this.atToCard = 0;
      }
    }
    // const result = this.SortedAvailableStore();
    // console.log("SortedAvailableStore", result);
  },
  methods: {
    $priceFormat(value) {
      return priceFormat(value);
    },
    async increment(info) {
      try {
        await this.$store.dispatch("cart/incrementProduct", info);
      } catch (error) {
        console.log(error);
      }
    },
    async subtract(info) {
      try {
        await this.$store.dispatch("cart/decrementProduct", info);
        // if (message === "SUCCESS") {
        //   this.atToCard -= 1;
        // }
      } catch (error) {
        console.log(error);
      }
    },
    customQuantityDialog(info) {
      this.$q.dialog({
        title: "Edit quantity",
        message: "Type the quantity of the product you want.",
        prompt: {
          model: "",
          isValid: (val) => val >= 0,
          type: "number",
        },
        cancel: true,
        persistent: true,
      }).onOk( async (quantity) => {
        console.log('>>>> OK, quantity is ', info, quantity);
        await this.$store.dispatch('cart/updateProductQuantity', {
          data: info,
          quantity: parseInt(quantity - this.atToCard),
        })
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.q-btn__wrapper:before {
  box-shadow: none;
}
</style>

<style scoped>
.discount-price {
  font-size: 14px;
  color: #c72027;
  font-weight: 700;
  margin-left: 3px;
}
.text-sort {
  font-size: 28px;
  line-height: 1.4;
  color: #222;
  font-weight: 400;
}
.des-text {
  color: #9e9e9e;
  text-overflow: ellipsis;
  white-space: nowrap;
  font-size: 12px;
  padding: 4px 0 5px;
  overflow: hidden;
}
.card-product {
  background-color: #fff;
}
.card-product:hover {
  /* box-shadow: 0 0 6px 0 rgba(0, 0, 0, 0.2); */
  cursor: pointer;
}
.special-price {
  color: #282669;
  font-weight: 700;
  font-size: 14px;
}
.name-item {
  font-size: 13px;
  /* font-weight: 700; */
  line-height: 17px;
}
.unit-price {
  font-size: 10px;
  font-weight: 400;
  color: #888;
}
.price {
  color: #b0b0b0;
  text-decoration: line-through;
  /* font-weight: 700; */
  font-size: 14px;
  margin-left: 4px;
}
.special-price {
  color: #282669;
  font-weight: 700;
  font-size: 16px;
}
.btn-cart {
  font-size: 16px;
  font-weight: 700;
  color: #8a030d;
}
>>> .q-infinite-scroll__loading {
  width: 100%;
}
>>> .q-btn__wrapper:before {
  box-shadow: none;
}
.text-dark-grey {
  color: #606060;
}
.brand {
  color: #2c2a74;
  font-weight: 600;
  font-size: 15px;
}
.name-item {
  font-size: 16px;
  font-weight: 400;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;
}
.unit-price {
  font-size: 10px;
  font-weight: 400;
  color: #888;
  margin-left: 2px;
}
.detail {
  border-top-left-radius: 14px;
  border-bottom-left-radius: 14px;
  padding-left: 10px;
  justify-content: space-between;
}
.detail::before {
  content: "";
  position: absolute;
  bottom: 0px;
  right: 6px;
  height: 1px;
  width: 65.7%;
  background-color: #eee;
}
.q-badge {
  font-size: 10px;
  padding: 2px 6px;
}
.description {
  font-size: 13px;
}
.pricing {
  flex-wrap: nowrap;
}
.img {
  max-height: 100px;
}
.overlay {
  position: absolute;
  width: 26px;
  height: 26px;
  top: 4px;
  left: 4px;
}
.overlay-right {
  position: absolute;
  width: 32px;
  height: 32px;
  top: 4px;
  left: 4px;
}
</style>
